/* eslint-disable react/no-danger */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useAlert from '../hooks/useAlert';
import {
  checkEngChars,
  CheckingValidComment,
  CheckingValidSearch,
  getCommentErrorMsg,
  hasJdMartVertical,
  helpfulObjData,
  clickTracker,
  getProjectId,
  empList,
} from '../lib/common';
import { onClickEvent } from '../lib/gaAnalytics';
import { CommonPopup, Shimmer } from '../components';
import { GenioWithAuth, usePopup } from '../hooks';
import styles from '../styles/Accordion.module.scss';
import styles2 from '../components/Ecs/EcsPortal.module.scss';
import { CreateTicket, GetGenioFaqs, PostIssueSubmit } from '../api';
import RaiseTicket from './RaiseTicket';
import { useAppState } from '../contexts/appState';
import { ShareLinkModal } from '../components/Genio';
import useClickAwayListener from '../hooks/useClickAwayLitsner';

function GenioFaq() {
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessData = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [appState] = useAppState();
  const { popupObj } = appState;
  const [selectedQsn, setSelectedQsn] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const [searchQuestion, setSearchQuestion] = useState('');
  const [faqResponse, setFaqResponse] = useState([]);
  const [selectedIssueSubIssue, setSelectedIssueSubIssue] = useState({
    selectedIssue: '',
    selectedSubIssue: '',
  });
  const [loading, setLoading] = useState(true);
  const [issueComment, setIssueComment] = useState('');
  const [comments, setComments] = useState({});
  const [setAlert] = useAlert();
  const params = useParams();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showData, setShowData] = useState(false);
  const [setPopup] = usePopup();
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [helpful, setHelpful] = useState(helpfulObjData);
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const popupRef = useRef(null);
  const projectId = getProjectId();

  const handleFaqClick = async (faqObj, index) => {
    setSelectedQsn(index);
    setShowData(true);
    if (index === activeIndex && faqsFeedbackData[faqObj?.id] === 'NotHelpful') {
      const updatedData = { ...faqsFeedbackData };
      delete updatedData[faqObj?.id];
      setFaqsFeedbackData(updatedData);
      sessionStorage.setItem('faqsFeedback', JSON.stringify(updatedData));
    }
    setActiveIndex(index === activeIndex ? -1 : index);
    setSelectedQuestionId(selectedQuestionId === faqObj?.pop ? null : faqObj?.pop);
    onClickEvent(`GENIO-FAQ Page-Selected Question`, faqObj?.question || '', faqObj?.question || '');
    setSelectedIssueSubIssue({
      selectedIssue: faqObj.issue || '',
      selectedSubIssue: faqObj.subIssue || '',
    });
  };

  useEffect(() => {
    const storedFeedbackData = sessionStorage.getItem('faqsFeedback');
    if (storedFeedbackData) {
      setFaqsFeedbackData(JSON.parse(storedFeedbackData));
    }
  }, []);

  const handlePostIssueClick = () => {
    document.body.style.overflow = 'hidden';
    setComments({});
    setSelectedQuestionId(null);
    setIssueComment('');
    onClickEvent(`GENIO-FAQ Page`, 'Suggestion Popup', 'Suggestion Popup');
    setPopup({
      open: true,
      popupType: 'postIssue',
      heading: 'Help us get better, let us know your issue/suggestion about the customer service',
      placeholder: 'Write your issue/suggestion & submit',
    });
  };

  const handleClosePopup = () => {
    document.body.style.overflow = 'unset';
    setPopup({});
  };

  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');
  useEffect(() => {
    if (searchQid && searchQid !== '') {
      faqData?.forEach((faq, i) => {
        if (faq?.id?.toString() === searchQid) {
          handleFaqClick(faq, i);
        }
      });
    }
  }, [faqData]);

  useEffect(() => {
    const handleGetGenioFaqs = async () => {
      if (params.key) {
        try {
          const paramsData = {
            key: params.key || '',
            parentId: selectedBusinessData.parentId || '',
            city: selectedBusinessData.city ? encodeURIComponent(selectedBusinessData.city) : '',
          };
          const res = await GetGenioFaqs(paramsData);
          if (res.errorCode === 0) {
            setLoading(false);
            setFaqData(res.result || []);
            if (searchQid && searchQid !== '') {
              res.result?.forEach((ele, i) => {
                if (ele?.id?.toString() === searchQid) {
                  res.result?.splice(i, 1);
                  res.result?.unshift(ele);
                }
              });
            }
            setFaqResponse(res.result || []);
          }
        } catch (e) {
          console.log(e);
        }
      }
    };
    handleGetGenioFaqs();
  }, []);

  useEffect(() => {
    setFaqsFeedbackData({});
  }, []);

  const handleSearchFaq = (e) => {
    setSearchQuestion(e.target.value);
    const filteredFaqData =
      faqResponse && faqResponse.filter((each) => each.question.toLowerCase().includes(e.target.value.toLowerCase()));
    setFaqData(filteredFaqData);
  };

  const handleSubmit = async (e, idx) => {
    onClickEvent(`GENIO-FAQ Page`, 'Ticket Submit', 'Ticket Submit');
    e.preventDefault();
    setActiveIndex(null);
    if (selectedBusinessData?.mobile) {
      if (CheckingValidComment(comments?.[idx])) {
        const paramsObj = {
          vertical: hasJdMartVertical()
            ? 'JD MART CORPORATE'
            : selectedIssueSubIssue?.selectedIssue?.startsWith('UBL')
              ? 'GBL'
              : params?.key === 'ecs'
                ? 'Retention'
                : 'LISTING',
          category: 'CS',
          ticket_creator: 'BUSINESS',
          nm: selectedBusinessData?.contractPersonName || selectedBusinessData?.companyName || '',
          created_by: profile?.mobile || '',
          mob: selectedBusinessData?.mobile || '',
          issue_type: selectedIssueSubIssue?.selectedIssue || '',
          issue_sub_type: selectedIssueSubIssue?.selectedSubIssue || '',
          issue_comment: comments?.[idx] ? comments?.[idx].trim() : '',
          document: document || [],
          city: selectedBusinessData?.city || '',
          oid: '',
          orderId: '',
          docid: selectedBusinessData?.docId || '',
          src: 'sales-genio',
          src_typ: empList.includes(profile.empCode)
            ? 'Genio – Market Research'
            : selectedBusinessData?.concern === 'client'
              ? 'client'
              : 'internal',
          src_nm: profile?.full_name || '',
          src_mob: profile?.mobile || '',
          projectId: '',
          parentId: selectedBusinessData?.parentId || '',
          compnm: selectedBusinessData?.companyName || '',
          source: 'description box_submitbutton_genio',
          ...(projectId === 'genio' && {
            agent_mngr_id: profile?.reporteeCode,
            agent_id: profile?.empCode,
          }),
        };
        const res = await CreateTicket(paramsObj);
        if (res?.errorCode === 0) {
          setAlert({
            message: res?.result?.msg || 'Success',
            status: true,
          });
        } else {
          setAlert({
            message: res?.message || 'Error',
            status: false,
          });
        }
      }
    } else {
      setAlert({
        message: 'No Mobile number found in the contract. Validate with Database team.',
        status: false,
      });
    }
    setComments({ ...comments, [idx]: '' });
  };

  const enableSubmitButton =
    CheckingValidComment(comments?.[selectedQsn] || '') && checkEngChars(comments?.[selectedQsn]);

  const handleIssueSubmit = async () => {
    onClickEvent(`GENIO-FAQ Page`, 'Suggestion Submit', 'Suggestion Submit');
    document.body.style.overflow = 'unset';
    if (profile?.empEmail) {
      if (CheckingValidComment(issueComment)) {
        const body = {
          email_subject: `CS-Sales flow | ${profile?.city || ''} | Suggestion`,
          sender_email: profile?.empEmail || '',
          sender_name: profile?.full_name || '',
          email_cc: profile?.empEmail || '',
          email_text: issueComment?.trim() || '',
        };
        const res = await PostIssueSubmit(body);
        if (res.errorCode === 0) {
          setAlert({
            message: res?.message || 'Success',
            status: true,
          });
        } else {
          setAlert({
            message: res?.message || 'Error',
            status: false,
          });
        }
      }
    } else {
      setAlert({
        message: 'Please update Email Id',
        status: false,
      });
    }

    setIssueComment('');
    setPopup({});
  };

  const handleHelpfulClick = async (index, apiKey, faqId) => {
    const value = index === 0 ? 'Helpful' : 'NotHelpful';

    const updatedData = {
      ...faqsFeedbackData,
      [faqId]: value,
    };
    setFaqsFeedbackData(updatedData);
    sessionStorage.setItem('faqsFeedback', JSON.stringify(updatedData));

    onClickEvent(`CSFAQ-helpful`, value === 'Helpful' ? 'Helpful' : 'Not Helpful', `FAQ-${faqId}`);

    await clickTracker(`${apiKey}_${value === 'Helpful' ? 'yes' : 'no'}`, 'faq_feedback');
  };

  const handleTicketCreate = () => {
    setSelectedQuestionId(null);
    onClickEvent(`GENIO_FAQ Page`, 'Raise CS Ticket', 'Raise CS Ticket');
    if (selectedBusinessData?.parentId && selectedBusinessData?.city) {
      navigate(
        `/genio/create_ticket?parentId=${selectedBusinessData?.parentId}&city=${selectedBusinessData?.city}&key=${params.key}`,
      );
    }
  };

  const handleCloseShareLinkPopup = () => {
    setPopup({});
  };
  const validSearchValue = CheckingValidSearch(searchQuestion);

  useClickAwayListener(popupRef, () => {
    handleClosePopup();
  });

  return (
    <>
      <section className="cspage csfaq no-highlighting">
        <div className="csfaqexpand p-20">
          <div className="csinstans font16 fw600 color111 text_center mt-5 ">
            Questions? We&apos;ve got <br />
            instant answers
          </div>
          <div className={`${styles.Accordion__Search} mt-10`}>
            <input
              value={searchQuestion}
              onChange={handleSearchFaq}
              type="search"
              placeholder="Search for keywords..."
              className={`${styles.Accordion__Input} font12 fw500 color111`}
            />
          </div>
          {!validSearchValue && searchQuestion && (
            <span className="colorEC4 font12">Please avoid special characters.</span>
          )}
          <div className="mt-10">
            {loading ? (
              <Shimmer loading={loading} id="faq" />
            ) : (
              <>
                {faqData && faqData?.length > 0 ? (
                  <>
                    {faqData &&
                      faqData.map((each, idx) => {
                        const hideHelpful =
                          ['smartassistant', 'jiohotstar', 'bookappointment'].includes(params.key.toLowerCase()) &&
                          (!each?.issue || !each?.subIssue);

                        return (
                          <div key={idx}>
                            <div
                              onClick={() => handleFaqClick(each, idx)}
                              role="button"
                              tabIndex={0}
                              onKeyDown={() => {}}
                              className={`${styles.Accordion__Pannel__Heading} ${
                                activeIndex === idx ? styles.Active : ''
                              }`}
                            >
                              <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                                {each?.question || ''}
                              </div>
                              <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                            </div>

                            {showData && (
                              <>
                                <div className={`${styles.Accordion__Contant}`}>
                                  <div className={`${styles.Accordion__TextContant}`}>
                                    {['popup', 'create'].includes(each?.type) ? (
                                      <>
                                        {each.type === 'create' && (
                                          <div
                                            aria-hidden="true"
                                            id="faqPage-ans"
                                            className="color777 font12 p-10"
                                            dangerouslySetInnerHTML={{ __html: each?.ans }}
                                          />
                                        )}

                                        <div className="csexpndwp active">
                                          <div className="csexpndwp_content">
                                            <div className="mb-10">
                                              <div className="font12 color1A1 mt-12">
                                                Description<span className="colorEC4">*</span>:
                                              </div>
                                            </div>
                                            <textarea
                                              value={comments?.[idx] || ''}
                                              className={`${styles2.Accordion__TextArea}`}
                                              onChange={(e) => setComments({ ...comments, [idx]: e.target.value })}
                                              rows="4"
                                              cols="50"
                                              placeholder="Tell us how we can improve this answer..."
                                            />

                                            <button
                                              onClick={(e) => handleSubmit(e, idx)}
                                              type="button"
                                              className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-10`}
                                              style={{
                                                backgroundColor: `${enableSubmitButton ? '#0076d7' : '#CCCCCC'}`,
                                                border: `1px solid ${!enableSubmitButton ? '#E0E0E0' : '#CCCCCC'}`,
                                                transitionProperty:
                                                  'background-color, background-image, border-color, box-shadow',
                                                transition: 'all 0.8s',
                                                color: `#FFFFFF`,
                                              }}
                                              disabled={!enableSubmitButton}
                                            >
                                              Submit
                                            </button>

                                            {!enableSubmitButton &&
                                              comments?.[selectedQsn] &&
                                              comments?.[selectedQsn].length > 3 && (
                                                <span className="colorEC4 font12">
                                                  {getCommentErrorMsg(comments?.[selectedQsn])}
                                                </span>
                                              )}
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {faqsFeedbackData[each.id] === 'NotHelpful' ? (
                                          <div className="csexpndwp active mt-10">
                                            <div className="csexpndwp_content">
                                              <div className="mb-10">
                                                <div className="font12 color1A1 mt-12">
                                                  Description<span className="colorEC4">*</span>:
                                                </div>
                                              </div>
                                              <textarea
                                                value={comments?.[idx] || ''}
                                                className={`${styles2.Accordion__TextArea}`}
                                                onChange={(e) => setComments({ ...comments, [idx]: e.target.value })}
                                                rows="4"
                                                cols="50"
                                                placeholder="Tell us how we can improve this answer..."
                                              />
                                              <button
                                                onClick={(e) => handleSubmit(e, idx)}
                                                type="button"
                                                className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-10`}
                                                style={{
                                                  backgroundColor: `${enableSubmitButton ? '#0076d7' : '#CCCCCC'}`,
                                                  border: `1px solid ${!enableSubmitButton ? '#E0E0E0' : '#CCCCCC'}`,
                                                  transitionProperty:
                                                    'background-color, background-image, border-color, box-shadow',
                                                  transition: 'all 0.8s',
                                                  color: `#FFFFFF`,
                                                }}
                                                disabled={!enableSubmitButton}
                                              >
                                                Submit
                                              </button>
                                              {!enableSubmitButton &&
                                                comments?.[selectedQsn] &&
                                                comments?.[selectedQsn].length > 3 && (
                                                  <span className="colorEC4 font12">
                                                    {getCommentErrorMsg(comments?.[selectedQsn])}
                                                  </span>
                                                )}
                                            </div>
                                          </div>
                                        ) : (
                                          <>
                                            <div
                                              id="faqPage-ans"
                                              className="color777 font12 p-10"
                                              dangerouslySetInnerHTML={{
                                                __html: each.ans,
                                              }}
                                            />

                                            {!hideHelpful && (
                                              <div className={`${styles.Accordion__Helpful} mt-20 mb-10`}>
                                                <div className="font11 fw400 color777 mr-10">Was this Helpful?</div>

                                                {helpful &&
                                                  helpful.map((item) => (
                                                    <div
                                                      key={item.id}
                                                      role="button"
                                                      tabIndex={0}
                                                      onClick={() =>
                                                        handleHelpfulClick(item.id, each.faqKey || each.apiKey, each.id)
                                                      }
                                                      onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                          handleHelpfulClick(
                                                            item.id,
                                                            each.faqKey || each.apiKey,
                                                            each.id,
                                                          );
                                                        }
                                                      }}
                                                      className={`${item?.icon} ${
                                                        (item.id === 0 && faqsFeedbackData[each.id] === 'Helpful') ||
                                                        (item.id === 1 && faqsFeedbackData[each.id] === 'NotHelpful')
                                                          ? styles.Active
                                                          : ''
                                                      } csicon mr-10`}
                                                      aria-label={item.id === 0 ? 'Helpful' : 'Not helpful'}
                                                    />
                                                  ))}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        );
                      })}

                    <RaiseTicket handleTicketCreate={handleTicketCreate} handlePostIssueClick={handlePostIssueClick} />
                  </>
                ) : (
                  validSearchValue && <div className="no-data-div">No Data</div>
                )}
              </>
            )}
          </div>
        </div>
      </section>
      {popupObj?.popupType === 'shareLinkPopup' && (
        <ShareLinkModal popupRef={popupRef} handleCloseShareLinkPopup={handleCloseShareLinkPopup} setAlert={setAlert} />
      )}
      {popupObj?.popupType === 'postIssue' && (
        <CommonPopup
          comment={issueComment}
          setComment={setIssueComment}
          handleCommentSubmit={handleIssueSubmit}
          handleClosePopup={handleClosePopup}
        />
      )}
    </>
  );
}

export default GenioWithAuth(GenioFaq);
